module.exports = __webpack_public_path__ + "media/images/icons/quick-fe1d0352c6da882d27ad8a26f5622864.png";